import React from 'react'
import Button, {ButtonProps} from '@mui/material/Button'
import styled from 'styled-components'
import button_prevnextStyles from './button_prevnext.styles'
import SvgIconAtom from '../../to_content/svg_icon/svg_icon.atom'
import TypographyAtom from '../../to_content/typography/typography.atom'

interface ApButtonProps extends ButtonProps {
  ap_type: 'next' | 'prev'
}
const apAtomName = {ap_atom_name: 'buttonPrevnextAtom'}

const ButtonPrevnextAtom = styled((props: ApButtonProps) => {
  return (
    <Button {...apAtomName} {...props}>
      {props.ap_type === 'next' && (
        <>
          <TypographyAtom ahd_type="navLink">{props.ap_type}</TypographyAtom>
          <SvgIconAtom ap_type="navigateNext" />
        </>
      )}

      {props.ap_type === 'prev' && (
        <>
          <SvgIconAtom ap_type="navigatePrevious" />
          <TypographyAtom ahd_type="navLink">{props.ap_type}</TypographyAtom>
        </>
      )}
    </Button>
  )
})`
  ${button_prevnextStyles}
`

export default ButtonPrevnextAtom
